import BlankCouponDownload from '@components/blank/BlankCouponDownload';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import styled from '@emotion/styled';

import CouponFilter from './CouponFilter';
import DownloadAbleCoupon from './DownloadAbleCoupon';
import useDownloadAbleCoupons from './hooks/useDownloadAbleCoupons';

function DownloadCouponFragment() {
  const {
    coupons, sorter, setSorter, fetchNext, setPage,
  } = useDownloadAbleCoupons();
  return (
        <Column fullWidth>
            <CouponFilter sorter={sorter}
                          setSorter={setSorter}/>
            <Container spacing={16} align='center' fullWidth>
                {coupons.length === 0 && (
                    <BlankCouponDownload/>
                )}
                {coupons.map((coupon) => (
                    <DownloadAbleCoupon coupon={coupon}
                                        setPage={setPage}
                                        key={coupon.eventId}/>
                ))}
                <InfinityScrollTrigger trigger={fetchNext} />
            </Container>
        </Column>
  );
}

const Container = styled(Column)`
padding: 0 20px
`;

export default DownloadCouponFragment;
